import { useState } from 'react'
import { Sparkles, Save } from 'lucide-react'
import { api } from '@/util/api'
import { Badge, Button, Card, Checkbox, Notice } from '@/components/play'
import type { OrgResource } from '@/types/admin'

export function OrganizationFeatureFlagsPanel({
  organization,
  onChange,
}: {
  organization: OrgResource
  onChange: (organization: OrgResource) => void
}) {
  const savedDirectorEnabled = organization.attributes.feature_flags?.director_enabled
    ?? organization.attributes.director_enabled
    ?? false
  const [directorEnabled, setDirectorEnabled] = useState(savedDirectorEnabled)
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState<string | null>(null)

  async function saveFlags() {
    setSaving(true)
    setError(null)

    try {
      const res = await api.updateAdminOrganization(organization.id, {
        feature_flags: {
          director_enabled: directorEnabled,
        },
      })
      onChange(res.data)
    } catch (err: any) {
      setDirectorEnabled(savedDirectorEnabled)
      setError(err?.response?.data?.error?.message || 'Could not save feature flags.')
    } finally {
      setSaving(false)
    }
  }

  return (
    <Card
      title="AI Producer"
      icon={<Sparkles />}
      description="Start events from a prompt."
      actions={
        <Badge tone={savedDirectorEnabled ? 'neutral' : 'quiet'}>
          {savedDirectorEnabled ? 'Enabled' : 'Disabled'}
        </Badge>
      }
    >
      <div className="space-y-4">
        {error && (
          <Notice tone="error" alert>{error}</Notice>
        )}

        <Checkbox
          label="Enable AI Producer"
          checked={directorEnabled}
          onCheckedChange={(checked) => setDirectorEnabled(checked)}
        />

        <div className="flex justify-end">
          {/* Secondary: the account's Save leads the page. */}
          <Button variant="secondary" size="compact" onClick={saveFlags} loading={saving} disabled={directorEnabled === savedDirectorEnabled}>
            {!saving && <Save />}
            Save
          </Button>
        </div>
      </div>
    </Card>
  )
}
